import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { faCaretDown, faFileExport, faTrash } from '@fortawesome/pro-solid-svg-icons';

import DeletionConfirmation from './deletion_confirmation';
import FileSystem from 'components/file_system';
import { fileSystemAdditionalColumns, excludedColumns } from './config';
import { renameFolder } from './api';

export default function Folder({
  deletable,
  folder,
  index,
  onChange,
  onClick,
  onDelete,
  onMoveUp,
  ...props
}) {
  const [deleting, setDeleting] = useState();

  const fileSystemFolder = useMemo(() => ({
    ...folder,
    folder: true,
    icon: 'folder',
  }), [folder]);

  const actions = useMemo(() => {
    const actions = [];

    if (folder.parentFolderId) {
      actions.push({
        key: 'moveUp',
        icon: faFileExport,
        label: 'Move to parent folder',
        callback: () => onMoveUp(folder),
      });
    }

    if (deletable) {
      actions.push({
        key: 'delete',
        icon: faTrash,
        label: 'Delete',
        callback: () => setDeleting(true),
      });
    }

    return actions;
  }, [folder]);

  function handleRename(folder, name) {
    if (name) {
      onChange(renameFolder(folder, name));
    }
  }

  return <React.Fragment>
    <FileSystem.Row
      actionIcon={faCaretDown}
      actions={actions}
      additionalColumns={fileSystemAdditionalColumns}
      excludedColumns={excludedColumns}
      file={fileSystemFolder}
      index={index}
      onNavigation={onClick}
      onRename={handleRename}
      {...props}
    />

    <DeletionConfirmation
      folder={folder}
      show={deleting}
      onClose={() => setDeleting(false)}
      onDelete={onDelete}
    />
  </React.Fragment>;
}

Folder.propTypes = {
  deletable: PropTypes.bool,
  folder: PropTypes.shape({
    parentFolderId: PropTypes.number,
  }).isRequired,
  index: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  onDelete: PropTypes.func.isRequired,
  onMoveUp: PropTypes.func,
};
